import type { Action, AnyAction, Dispatch } from '@reduxjs/toolkit';
import {
  fetchClientByClientIdRequest,
  fetchClientByClientIdResponse,
  putClientPartnerLinkForClientByClientIdResponse,
} from './clientModel';
import { AppState } from './store';
import { createSimpleMiddleware } from './createSimpleMiddleware';
import { isNullOrUndefined } from '@shared/isNullOrUndefined';
import { postAdvisorUpdatesByAdvisorIdResponse } from './advisorModel';
import {
  fetchPolicyApplicationsWithStatusUpdatesForClientByClientIdRequest,
  postPolicyApplicationEmailResponse,
} from './policyApplicationModel';
import { fetchPolicyApplicationsByPartnerClientIdForAdvisorRequest } from './partnerPolicyApplicationModel';

/**
 * Middleware to invalidate & refetch client data when a client is updated
 */
function invalidateClientMiddlewareImpl(
  dispatch: Dispatch<AnyAction>,
  getStore: () => AppState,
  next: Dispatch<AnyAction>,
  action: Action<string>,
) {
  next(action);

  if (
    action.type === postAdvisorUpdatesByAdvisorIdResponse.type ||
    action.type === putClientPartnerLinkForClientByClientIdResponse.type
  ) {
    setTimeout(() => fetchCurrentClient(dispatch, getStore));
  }

  if (
    action.type === fetchClientByClientIdResponse.type ||
    action.type === postPolicyApplicationEmailResponse.type
  ) {
    setTimeout(() => {
      fetchClientPolicyApplications(dispatch, getStore);
      fetchPartnerClientPolicyApplications(dispatch, getStore);
    });
  }
}

export const invalidateClientMiddleware = createSimpleMiddleware(
  invalidateClientMiddlewareImpl,
);

export function fetchCurrentClient(
  dispatch: Dispatch<AnyAction>,
  getStore: () => AppState,
) {
  const clientData = getStore().client.data;
  if (!isNullOrUndefined(clientData?.clientId)) {
    // Fetch fresh client data
    dispatch(fetchClientByClientIdRequest(clientData!.clientId));
  }
}

function fetchClientPolicyApplications(
  dispatch: Dispatch<AnyAction>,
  getStore: () => AppState,
) {
  const clientData = getStore().client.data;
  if (!isNullOrUndefined(clientData?.clientId)) {
    dispatch(
      fetchPolicyApplicationsWithStatusUpdatesForClientByClientIdRequest({
        clientId: clientData!.clientId,
      }),
    );
  }
}

function fetchPartnerClientPolicyApplications(
  dispatch: Dispatch<AnyAction>,
  getStore: () => AppState,
) {
  const clientData = getStore().client.data;
  if (!isNullOrUndefined(clientData?.clientId)) {
    dispatch(
      fetchPolicyApplicationsByPartnerClientIdForAdvisorRequest({
        partnerClientId: clientData!.clientId,
      }),
    );
  }
}
